module.exports = __webpack_public_path__ + "img/ico_overview_left.e70dee05.svg";